import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';

const { Search } = Input;

@inject('ItemRoomTypeStore')
@observer
class ItemRoomTypeSearchTypeModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'Room Type',
                dataIndex: 'roomTypeName',
                key: 'roomName',
                width: '90%'
            },
            {
                title: 'Action',
                dataIndex: 'roomTypeId',
                key: 'roomTypeId',
                width: '10%',
                render: record => {
                    const { roomTypeId } = this.props.ItemRoomTypeStore;

                    if (roomTypeId !== record)
                    return (
                        <span>
                            <Button onClick={() => this.selectRoomTypeOnClick(record)} type='primary'>
                                Select
                            </Button>
                        </span>
                    )
                },
            },
        ]
    }

    // ON CHANGE

    roomTypeOnChange = e => {
        this.props.ItemRoomTypeStore.setRoomTypeSearchValue(e.target.value);
        this.props.ItemRoomTypeStore.searchRoomType();
    }

    // ON CLICK

    selectRoomTypeOnClick = roomId => {
        this.props.ItemRoomTypeStore.searchRoomTypeSelected(roomId);
        this.props.ItemRoomTypeStore.setShowRoomTypeSearchModal(false);
    }

    render() {
        const {
            roomTypeFilter,
            roomTypeSearchValue
        } = this.props.ItemRoomTypeStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder='Search Room Type' value={roomTypeSearchValue} onChange={this.roomTypeOnChange} />
                <Table columns={this.getColumns()} dataSource={roomTypeFilter} />
            </React.Fragment>
        )
    }
}

export default ItemRoomTypeSearchTypeModalPage;